import React from 'react';
import { ChevronRightIcon } from "@navikt/aksel-icons";

export const HoyreChevron = () => {
    return <ChevronRightIcon title="Høyresjevron" style={{verticalAlign:"bottom", scale:"1.3"}} aria-hidden="true"/>
}
